import { UserRole, UserRoleType } from '@/dashboard/types/user_role';

export const OwnerRole: UserRoleType[] = [UserRole.Owner];
export const OwnerAdminRoles: UserRoleType[] = [UserRole.Owner, UserRole.Admin];
export const OwnerAdminCreator: UserRoleType[] = [UserRole.Owner, UserRole.Admin, UserRole.Creator];
export const OwnerAdminCreatorViewerRoles: UserRoleType[] = [UserRole.Owner, UserRole.Admin, UserRole.Creator, UserRole.Viewer];
export const OwnerAdminCreatorViewerClientRoles: UserRoleType[] = [
  UserRole.Owner,
  UserRole.Admin,
  UserRole.Creator,
  UserRole.Viewer,
  UserRole.Client,
];
